import React, { useId } from 'react'
import { SuperGrain } from '../SuperGrain'

export const SimpleBluePink = ({
  hideGrain,
  svgProps,
}: {
  hideGrain?: boolean
  svgProps: React.SVGProps<SVGSVGElement>
}) => {
  const uniqueId = useId()
  const grainMaskId1 = `grainFilter-simple-blue-1-${uniqueId}`
  const cutoutMaskId = `cutout-mask-${uniqueId}`

  return (
    <svg
      {...svgProps}
      viewBox="0 0 1602 1139"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4716_2202)">
        <g mask={`url(#${cutoutMaskId})`}>
          <g filter="url(#filter0_f_4716_2202)">
            <ellipse
              cx="758.846"
              cy="702"
              rx="528.658"
              ry="519.69"
              transform="rotate(-30.7308 758.846 661.861)"
              fill="#176AE5"
            />
          </g>
          <g opacity="0.7" filter="url(#filter1_f_4716_2202)">
            <circle cx="913.999" cy="797.949" r="375" fill="#EF91F7" />
          </g>
          <g opacity="0.7" filter="url(#filter2_f_4716_2202)">
            <circle cx="1084" cy="811.949" r="375" fill="#EBB9CB" />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_4716_2202"
          x="77.8941"
          y="-14.7978"
          width="1361.9"
          height="1353.32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="77.2675"
            result="effect1_foregroundBlur_4716_2202"
          />
        </filter>
        <filter
          id="filter1_f_4716_2202"
          x="420.522"
          y="304.472"
          width="1602"
          height="1139"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="59.2384"
            result="effect1_foregroundBlur_4716_2202"
          />
        </filter>
        <filter
          id="filter2_f_4716_2202"
          x="590.522"
          y="318.472"
          width="1602"
          height="1139"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="59.2384"
            result="effect1_foregroundBlur_4716_2202"
          />
        </filter>
        <filter
          id="filter3_f_4716_2202"
          x="-899.404"
          y="294.327"
          width="2951.35"
          height="1851.86"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="100"
            result="effect1_foregroundBlur_4716_2202"
          />
        </filter>
        <clipPath id="clip0_4716_2202">
          <rect width="1602" height="1139" fill="white" />
        </clipPath>
        <mask id={cutoutMaskId}>
          <rect width="100%" height="100%" fill="white" />
          <g filter="url(#filter3_f_4716_2202)">
            <ellipse
              cx="576.269"
              cy="1220.26"
              rx="1326.69"
              ry="627.413"
              transform="rotate(18.1953 576.269 1220.26)"
              fill="black"
            />
          </g>
        </mask>
        <mask id={grainMaskId1}>
          <rect width="100%" height="100%" fill="black" />
          <g filter="url(#filter0_f_4716_2202)">
            <ellipse
              cx="758.846"
              cy="702"
              rx="528.658"
              ry="519.69"
              transform="rotate(-30.7308 758.846 661.861)"
              fill="white"
            />
          </g>
          <g opacity="0.7" filter="url(#filter1_f_4716_2202)">
            <circle cx="913.999" cy="797.949" r="375" fill="white" />
          </g>
          <g opacity="0.7" filter="url(#filter2_f_4716_2202)">
            <circle cx="1084" cy="811.949" r="375" fill="white" />
          </g>
          <g filter="url(#filter3_f_4716_2202)">
            <ellipse
              cx="576.269"
              cy="1220.26"
              rx="1326.69"
              ry="627.413"
              transform="rotate(18.1953 576.269 1220.26)"
              fill="black"
            />
          </g>
        </mask>
      </defs>
      {!hideGrain && (
        <foreignObject
          x="0"
          y="0"
          width="100%"
          height="100%"
          mask={`url(#${grainMaskId1})`}
        >
          <SuperGrain zIndex={0} />
        </foreignObject>
      )}
    </svg>
  )
}
